import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { eagerProvider } from '../util';
import { PwaAppVersionService } from './pwa-app-version.service';
import { UnrecoverableErrorComponent } from './unrecoverable-error/unrecoverable-error.component';
import { UpdateAvailableComponent } from './update-available/update-available.component';
import {
  VersionWatcherOptions,
  provideVersionWatcherOptions,
} from './version-watcher-options';

export * from './pwa-app-version.service';
export * from './version-watcher-options';

export function providePwaAppVersionWatcher(
  options?: VersionWatcherOptions
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideVersionWatcherOptions(options),
    eagerProvider(PwaAppVersionService),
  ]);
}

export const PWA_APP_VERSION_WATCHER_DECLARATIONS = [
  UnrecoverableErrorComponent,
  UpdateAvailableComponent,
] as const;
